const TermsOfService = () => {
  return (
    <div className="terms-of-service-page">
      {/* Hero Section */}
      <section 
        className="relative min-h-[60vh] flex items-center overflow-hidden bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/images/testbackgroundoneai5.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center px-4 py-2 bg-white/95 text-blue-700 rounded-full text-sm font-semibold mb-8 backdrop-blur-sm shadow-lg">
              Legal
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 drop-shadow-lg">
              Terms of Service
            </h1>
            
            <p className="text-xl text-white leading-relaxed max-w-3xl mx-auto drop-shadow-md">
              Please read these terms carefully before using our AI consulting services.
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto prose prose-lg">
            <p className="text-gray-600 mb-8">
              <strong>Last updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
                <p className="text-gray-600">
                  By accessing and using OneAI's services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by these terms, please do not use our services.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Description of Services</h2>
                <p className="text-gray-600 mb-4">OneAI provides:</p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2">
                  <li>Custom AI agent development and implementation</li>
                  <li>Business process automation consulting</li>
                  <li>Data intelligence and analytics solutions</li>
                  <li>AI integration services and technical support</li>
                  <li>Strategic consulting for digital transformation</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. User Responsibilities</h2>
                <p className="text-gray-600 mb-4">As a user of our services, you agree to:</p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2">
                  <li>Provide accurate and complete information during consultations</li>
                  <li>Comply with all applicable laws and regulations</li>
                  <li>Not use our services for illegal or unauthorized purposes</li>
                  <li>Maintain the confidentiality of any proprietary information shared</li>
                  <li>Pay all fees and charges according to agreed terms</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Intellectual Property</h2>
                <p className="text-gray-600 mb-4">
                  Unless otherwise specified in a separate agreement:
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2">
                  <li>OneAI retains ownership of all proprietary methods, frameworks, and general solutions</li>
                  <li>Clients retain ownership of their data and custom business logic</li>
                  <li>Custom AI solutions developed specifically for clients become client property upon full payment</li>
                  <li>Both parties respect each other's intellectual property rights</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Confidentiality</h2>
                <p className="text-gray-600">
                  We understand the sensitive nature of business information. OneAI commits to maintaining strict confidentiality regarding all client data, business processes, and proprietary information shared during our engagement. We will not disclose such information to third parties without explicit written consent.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Service Availability</h2>
                <p className="text-gray-600">
                  While we strive to provide continuous service availability, OneAI does not guarantee uninterrupted access to our services. We reserve the right to modify, suspend, or discontinue services for maintenance, updates, or other operational requirements.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Limitation of Liability</h2>
                <p className="text-gray-600">
                  OneAI's liability is limited to the amount paid for services. We are not liable for indirect, incidental, special, or consequential damages. Our AI solutions are provided "as is" and we make no warranties regarding performance outcomes, though we commit to professional best practices.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Payment Terms</h2>
                <p className="text-gray-600 mb-4">
                  Payment terms will be specified in individual service agreements. Generally:
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2">
                  <li>Consulting fees are due within 30 days of invoice</li>
                  <li>Development projects may require milestone-based payments</li>
                  <li>Late payments may incur additional fees</li>
                  <li>Refunds are considered on a case-by-case basis</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Termination</h2>
                <p className="text-gray-600">
                  Either party may terminate services with written notice. Upon termination, clients retain access to delivered solutions, and OneAI will provide reasonable transition assistance. Outstanding payments remain due regardless of termination.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Governing Law</h2>
                <p className="text-gray-600">
                  These terms are governed by the laws of [Your Jurisdiction]. Any disputes will be resolved through binding arbitration or in the courts of [Your Jurisdiction].
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Changes to Terms</h2>
                <p className="text-gray-600">
                  OneAI reserves the right to modify these terms at any time. Material changes will be communicated to clients with reasonable notice. Continued use of services constitutes acceptance of updated terms.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Contact Information</h2>
                <p className="text-gray-600 mb-4">
                  For questions about these Terms of Service, please contact us:
                </p>
                <div className="bg-gray-50 p-6 rounded-lg">
                  <p className="text-gray-600">
                    <strong>OneAI Consulting</strong><br />
                    Email: legal@oneaiconsulting.com
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default TermsOfService
